"use client";

import { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import color from "@/style/theme/Color";

interface CustomizedAccordionsProps {
  expanded?: string | number;
  data: Array<{
    key?: string;
    summary: string;
    details: string | React.ReactNode;
  }>;
}

const Accordion = styled((props: any) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const CustomizedAccordions: React.FC<CustomizedAccordionsProps> = (props) => {
  const [expanded, setExpanded] = useState<string | false>(
    props.expanded !== undefined ? String(props.expanded) : ""
  );
  const data = props.data;

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {data.map((element, defaultKey) => {
        const key = element.key ?? defaultKey.toString();

        return (
          <Accordion
            key={key}
            expanded={expanded === key}
            onChange={handleChange(key)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: color.light_white }} />}
              aria-controls={`panel${key}d-content`}
              id={`panel${key}d-header`}
              sx={{
                backgroundColor: color.primary,
                color: color.light_white,
              }}
            >
              <Typography>{element.summary}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {typeof element.details === "string" ? (
                <Typography>{element.details}</Typography>
              ) : (
                element.details
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default CustomizedAccordions;
